






































import config from 'util/config';
import { Vue, Component, Ref } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form.d';

@Component
export default class LoginByPassword extends Vue {
  @Ref('loginByPasswordForm') readonly loginByPasswordForm!: ElForm;

  userInput = {
    phone: '',
    password: '',
  };

  rules = {
    phone: [
      {
        required: true,
        pattern: /^1[3456789]\d{9}$/,
        message: '请输入正确的手机号',
        trigger: 'blur',
      },
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
    ],
  };

  isValidating = false;

  isRemembering = true;

  redirect = '';

  mounted() {
    const { phone, redirect } = this.$route.query;
    this.redirect = (redirect as string) || '/userCenter';
    if (phone) {
      this.userInput.phone = (phone as string);
    } else {
      const isRemembering = Vue.ls.get('isRemembering');
      if (isRemembering) {
        this.userInput.phone = Vue.ls.get('account');
        this.userInput.password = Vue.ls.get('password');
      }
      this.isRemembering = !!isRemembering;
    }
  }

  loginByPassword() {
    this.isValidating = true;
    this.loginByPasswordForm.validate((valid: boolean) => {
      if (valid) {
        if (this.isRemembering) {
          Vue.ls.set('account', this.userInput.phone, config.ACCOUNT_EXPIRE);
          Vue.ls.set('password', this.userInput.password, config.ACCOUNT_EXPIRE);
          Vue.ls.set('isRemembering', this.isRemembering, config.ACCOUNT_EXPIRE);
        } else {
          Vue.ls.remove('account');
          Vue.ls.remove('password');
          Vue.ls.remove('isRemembering');
        }
        this.$store.dispatch('Login', {
          mobilePhone: this.userInput.phone,
          password: this.userInput.password,
        }).then(() => {
          this.isValidating = false;
          this.$message.success('登录成功');
          this.$router.push({ path: this.redirect });
        }).catch(() => {
          this.isValidating = false;
        });
      } else {
        this.isValidating = false;
      }
    });
  }
}
